import React from "react"
import { Avatar, Grid, Box, Badge } from "@mui/material"
import { color } from "constant/constant"
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"
import { getUserAvatar } from "helper/User"
import { loadImages } from "helper/Image"

function MatchPlayer ({
    sideA, sideB
}) {
    console.log('here sideA', sideA, sideB)
    return (
        <Grid container xs={12}>
            <Grid item xs={4} md={3} textAlign={"center"}>
                <Box sx={{ textAlign: 'start', marginTop: 1, display: 'flex' }}>
                    {
                        sideA.map((value, index) => (
                            <Box key={value._id} sx={{
                                position: 'relative',
                                zIndex: sideA.length - index,
                                ml: index === 0 ? 0.8 : -1.5,
                                flexShrink: 0,
                            }}>
                                <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                badgeContent={
                                    <>
                                    {
                                        value.swapped &&
                                        <div style={{
                                            marginTop: 0,
                                            width: 10, height: 10,
                                            backgroundColor: color.blueIndoor_2,
                                            borderRadius: 5,
                                        }}>
                                            {/* <img style={{
                                                marginLeft: 2, marginBottom: 1
                                            }} src={exchange} width={7} height={7}/> */}
                                        </div>
                                    }
                                    </>
                                    // <SmallAvatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                                }>
                                    <Avatar
                                        key={value._id}
                                        onClick={(e) => {
                                            e.stopPropagation(true)
                                            // if (data.hideUsername) { return; }
                                            // handleClick(e, {
                                            //     ...value.user,
                                            //     appliedDate: value.appliedDate || null
                                            // })
                                        }}
                                        style={{
                                            width: {xs: 40, md: 60, lg: 60}, height: {xs: 40, md: 60, lg: 60},
                                        }}
                                        bgColor={"transparent"}
                                        src={getUserAvatar(value)} 
                                        // size={size}
                                        alt={value.name}
                                        sx={{
                                            // width: { xs: 35, sm: 43, md: 51 },
                                            // height: { xs: 35, sm: 43, md: 51 },
                                            width: {xs: 40, md: 60, lg: 60}, height: {xs: 40, md: 60, lg: 60},
                                            border: '1.5px solid white',
                                            flexShrink: 0,
                                            position: 'relative'
                                        }}
                                    />
                                </Badge>
                            </Box>
                        ))
                    }
                </Box>
                <Box sx={{ textAlign: 'start', marginTop: 1 }}>
                    { sideA.map(value => {
                        return(
                            <div key={value._id} style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                {/* {
                                    (value.club && !match.isTournament) &&
                                    <Grid item sx={{ ml: 0, position: 'relative'}}>
                                        {
                                            (canDrag && !match.isTournament) &&
                                            <PencilButton value={value} replacePlayerId={replacePlayerId} setReplacePlayer={setReplacePlayer}/>
                                        }
                                        <Avatar sx={{...clubSize}} src={value.club ? value.club.logo : clubPlaceholder} />
                                    </Grid>
                                } */}
                                <Grid item sx={{ mt: 0.2, ml: 0.2, position: 'relative'}}>
                                    <TCLabel subtitle bold overflowLine={1}>{value.name}</TCLabel>
                                </Grid>
                            </div>
                        )
                    })}
                </Box>
            </Grid>
            <Grid item xs={4} md={3} textAlign={"center"}>
                <Box sx={{ textAlign: 'start', marginTop: 1, display: 'flex' }}>
                    {
                    sideB.map((value, index) => (
                        <Box key={value._id} sx={{
                            position: 'relative',
                            zIndex: sideA.length - index,
                            ml: index === 0 ? 0.8 : -1.5,
                            flexShrink: 0,
                        }}>
                            <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <>
                                {
                                    value.swapped &&
                                    <div style={{
                                        marginTop: 0,
                                        width: 10, height: 10,
                                        backgroundColor: color.blueIndoor_2,
                                        borderRadius: 5,
                                    }}>
                                        {/* <img style={{
                                            marginLeft: 2, marginBottom: 1
                                        }} src={exchange} width={7} height={7}/> */}
                                    </div>
                                }
                                </>
                                // <SmallAvatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                            }>
                                <Avatar
                                    key={value._id}
                                    onClick={(e) => {
                                        e.stopPropagation(true)
                                        // if (data.hideUsername) { return; }
                                        // handleClick(e, {
                                        //     ...value.user,
                                        //     appliedDate: value.appliedDate || null
                                        // })
                                    }}
                                    style={{
                                        width: {xs: 40, md: 60, lg: 60}, height: {xs: 40, md: 60, lg: 60}
                                    }}
                                    bgColor={"transparent"}
                                    src={getUserAvatar(value)} 
                                    // size={size}
                                    alt={value.name}
                                    sx={{
                                        // width: { xs: 35, sm: 43, md: 51 },
                                        // height: { xs: 35, sm: 43, md: 51 },
                                        width: {xs: 40, md: 60, lg: 60}, height: {xs: 40, md: 60, lg: 60},
                                        border: '1.5px solid white',
                                        flexShrink: 0,
                                        position: 'relative'
                                    }}
                                />
                            </Badge>
                        </Box>
                    ))
                }
                </Box>
                <Box sx={{ textAlign: 'start', marginTop: 1 }}>
                    { sideB.map(value => {
                        return(
                            <div key={value._id} style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                {/* {
                                    (value.club && !match.isTournament) &&
                                    <Grid item sx={{ ml: 0, position: 'relative'}}>
                                        {
                                            (canDrag && !match.isTournament) &&
                                            <PencilButton value={value} replacePlayerId={replacePlayerId} setReplacePlayer={setReplacePlayer}/>
                                        }
                                        <Avatar sx={{...clubSize}} src={value.club ? value.club.logo : clubPlaceholder} />
                                    </Grid>
                                } */}
                                <Grid item sx={{ mt: 0.2, ml: 0.2, position: 'relative'}}>
                                    <TCLabel subtitle bold overflowLine={1}>{value.name}</TCLabel>
                                </Grid>
                            </div>
                        )
                    })}
                </Box>
            </Grid>
        </Grid>
    )
}

export default MatchPlayer